import { render, staticRenderFns } from "./OneplatformExtrnalConsent.vue?vue&type=template&id=75f12c53&scoped=true&"
import script from "./OneplatformExtrnalConsent.vue?vue&type=script&lang=js&"
export * from "./OneplatformExtrnalConsent.vue?vue&type=script&lang=js&"
import style0 from "./OneplatformExtrnalConsent.vue?vue&type=style&index=0&id=75f12c53&prod&lang=css&"
import style1 from "./OneplatformExtrnalConsent.vue?vue&type=style&index=1&id=75f12c53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f12c53",
  null
  
)

export default component.exports